<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card class="my-4" height="100%" width="100%">
                    <v-card-title><span>Στοιχεία σύμβασης</span><span v-if="contract.id" style="font-weight: bold;">&nbsp; {{ contract.title }}</span></v-card-title>
                    
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-text-field label="Πελάτης" v-bind:value="contract.customer_name" readonly> </v-text-field>
                                <v-text-field label="Ημ/νία έναρξης" v-bind:value="contract.start_date" readonly> </v-text-field>
                                <v-text-field label="Ημ/νία λήξης" v-bind:value="contract.end_date" readonly> </v-text-field>
                            </v-col>
                        
                            <v-col>
                                <v-text-field label="Ποσό σύμβασης" v-bind:value="contract.total_amount" readonly> </v-text-field>
                                <v-text-field label="Τιμολογημένα (καθαρά)" v-bind:value="totalsSum('invoices', 'net_amount', 2)" readonly> </v-text-field>
                                <v-text-field label="Τιμολογημένα (μικτά)" v-bind:value="totalsSum('invoices', 'amount', 2)" readonly> </v-text-field>
                                
                            </v-col>

                            <v-col>
                                <v-text-field label="Επόμενη τιμολόγηση" v-bind:value="nextInstallmentDate" readonly> </v-text-field>
                                <v-text-field label="Ποσό τιμολόγησης" v-bind:value="nextInstallmentAmount" readonly> </v-text-field>
                                <v-text-field label="Εισπραχθέντα" v-bind:value="totalsSum('payments', 'amount', 2)" readonly> </v-text-field>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-col>

            <v-col>
                <v-card class="my-4" height="100%" width="100%">
                    <v-card-title>Αρχεία σύμβασης <span v-if="showFilesCount" class="mx-2"> ({{ contractFilesCount }})</span>
                        <v-spacer/>
                        <v-btn text color="primary" @click="showAddFileDialog">ΠΡΟΣΘΗΚΗ</v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-list-item two-line v-for="file in contract.files" :key="file.id">
                                <v-list-item-icon>
                                    <v-progress-circular indeterminate v-if="file.is_being_deleted"></v-progress-circular>
                                    <v-icon @click="deleteFile(file)" v-else> mdi-delete </v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                    <v-list-item-title><a v-bind:href="getLink(file)" target="_new">{{file.original_file_name}}</a></v-list-item-title>
                                    <v-list-item-subtitle>Αποθήκευση: {{ getHumanDate(file.created_at) }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>    
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-dialog v-model="addFileDialog" max-width="350px">
                    <v-card>
                        <v-card-text>
                            <file-uploader title="Επιλογή αρχείου" filter=".pdf" v-bind:target="contractFilesUrl"></file-uploader>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card class="my-4">
                    <v-card-title>
                        <template>
                            <span>Πρόγραμμα τιμολόγησης</span>
                            <v-spacer/>
                            <v-btn text color="primary" dark class="m-2" @click="showAddItemDialog">ΝΕΟ</v-btn> 
                        </template>
                    </v-card-title>
                    
                    <v-card-text>
                        <v-data-table
                            :headers="scheduleTableHeaders"
                            :items="installments"
                            :item-class="tableRowClassGenerator"
                            :sort-by="['due_date', 'amount']"
                            class="elevation-1"
                            :disable-sort="true"
                            :disable-pagination="true"
                            :disable-filtering="true"
                            :hide-default-footer="true">

                                <template slot="top">
                                    <v-dialog v-model="dialogDelete" max-width="350px">
                                        <v-card>
                                            <v-card-title class="text-h5">Διαγραφή εγγραφής</v-card-title>
                                            <v-card-text>
                                                <v-container>
                                                    <v-row>
                                                        <v-text-field readonly label="Ποσό" v-bind:value="`€ ${editedItem.amount}`"></v-text-field>
                                                    </v-row>
                                                    <v-row>
                                                        <v-text-field readonly label="Ημερομηνία" v-bind:value="editedItem.scheduled_date"></v-text-field>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="warning darken-1" text @click="closeDeleteItemDialog">ΑΚΥΡΟ</v-btn>
                                                <v-btn color="error darken-1" text @click="deleteScheduleItem(editedItem)">ΕΝΤΑΞΕΙ</v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>

                                    <v-dialog v-model="dialogEdit" max-width="350px" >
                                        <v-card>
                                            <v-card-title class="text-h5">Επεξεργασία εγγραφής</v-card-title>
                                            <v-card-text>
                                                <vuetify-money label="Ποσό" v-model="editedItem.amount"></vuetify-money>
                                                <v-menu
                                                    v-model="menu2"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            v-model="editedItem.scheduled_date_iso"
                                                            label="Ημερομηνία"
                                                            append-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on">
                                                        </v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        v-model="editedItem.scheduled_date_iso"
                                                        @input="menu2 = false">
                                                    </v-date-picker>
                                                </v-menu>  
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="warning darken-1" text @click="closeEditItemDialog">ΑΚΥΡΟ</v-btn>
                                                <v-btn color="error darken-1" text @click="updateScheduleItem(editedItem)">ΕΝΤΑΞΕΙ</v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>

                                    <v-dialog v-model="dialogCreate" max-width="350px" >
                                        <v-card>
                                            <v-card-title class="text-h5">Δημιουργια εγγραφής</v-card-title>
                                            <v-card-text>
                                                <vuetify-money label="Ποσό" v-model="editedItem.amount"></vuetify-money>
                                                <v-menu
                                                    v-model="menu2"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            v-model="editedItem.scheduled_date_iso"
                                                            label="Ημερομηνία έκδοσης"
                                                            append-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on">
                                                        </v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        v-model="editedItem.scheduled_date_iso"
                                                        @input="menu2 = false">
                                                    </v-date-picker>
                                                </v-menu>        
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="warning darken-1" text @click="closeAddItemDialog">ΑΚΥΡΟ</v-btn>
                                                <v-btn color="error darken-1" text @click="addScheduleItem(editedItem)">ΕΝΤΑΞΕΙ</v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>

                                </template>

                                
                                <template slot="body.append">
                                    <tr>
                                        <th>Σύνολο</th>
                                        <th class="text-right">{{totalsSum('installments', 'amount', 2)}}</th>
                                    </tr>
                                </template>

                                <template v-slot:[`item.actions`]="{ item }">
                                    <v-icon v-if="item.is_invoiced == false" small @click="showEditItemDialog(item)" class="mr-2" > mdi-pencil </v-icon>
                                    <v-icon v-if="item.is_invoiced == false" small @click="showDeleteItemDialog(item)"> mdi-delete </v-icon>
                                </template>
                            </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col>
                <v-card class="my-4">
                    <v-card-title>Τιμολόγια</v-card-title>
                    
                    <v-card-text>
                        <v-data-table
                            :headers="invoicesTableHeaders"
                            :items="invoices"
                            :item-class="tableRowClassGenerator"
                            :sort-by="['due_date', 'amount']"
                            class="elevation-1"
                            :disable-sort="true"
                            :disable-pagination="true"
                            :disable-filtering="true"
                            :hide-default-footer="true">
                            <template slot="body.append">
                                <tr>
                                    <th>Σύνολο</th>
                                    <th></th>
                                    <th class="text-right">{{totalsSum('invoices', 'net_amount', 2)}}</th>
                                    <th class="text-right">{{totalsSum('invoices', 'amount', 2)}}</th>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col>
                <v-card class="my-4">
                    <v-card-title>Εισπράξεις</v-card-title>
                    
                    <v-card-text>
                        <v-data-table
                            :headers="paymentsTableHeaders"
                            :items="payments"
                            :item-class="tableRowClassGenerator"
                            :sort-by="['due_date', 'amount']"
                            class="elevation-1"
                            :disable-sort="true"
                            :disable-pagination="true"
                            :disable-filtering="true"
                            :hide-default-footer="true"
                            >
                            <template slot="body.append">
                                <tr>
                                    <th>Σύνολο</th>
                                    <th></th>
                                    <th class="text-right">{{totalsSum('payments', 'amount', 2)}}</th>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        
        
    </v-container>
    
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    components: {
    },
    
    data() {
        return {

            contract: {},

            installments: [],
            invoices: [],
            payments: [],

            nextInstallment: {},
                
            scheduleTableHeaders: [
                {
                    'text' : 'Ημερομηνία',   
                    'value' : 'scheduled_date'
                },
                {
                    'text' : 'Ποσό τιμολόγησης',
                    'value' : 'amount',
                    'align' : 'right'
                },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            
            invoicesTableHeaders: [
                {
                    'text' : 'Ημερομηνία',   
                    'value' : 'issue_date'
                },
                {
                    'text' : 'Παραστατικό',   
                    'value' : 'document'
                },
                {
                    'text' : 'Καθαρό ποσό',
                    'value' : 'net_amount',
                    'align' : 'right'
                },
                {
                    'text' : 'Μικτό ποσό',
                    'value' : 'amount',
                    'align' : 'right'
                }
            ],

            paymentsTableHeaders: [
                {
                    'text' : 'Ημερομηνία',   
                    'value' : 'issue_date'
                },
                {
                    'text' : 'Παραστατικό',   
                    'value' : 'document'
                },
                {
                    'text' : 'Ποσό είσπραξης',
                    'value' : 'amount',
                    'align' : 'right'
                }
            ],

            editedItem: {},

            dialogDelete: null,
            dialogEdit: null,
            dialogCreate: null,

            menu2: false,

            addFileDialog: false,
            uploading: false,
        }
    },

    created() {
        this.initialize();
    },

    methods: {
        initialize() {
            axios.get('/api/contracts/' + this.$route.params.id)
            .then(response => {
                this.contract = response.data.data
                this.installments = response.data.data.installments.sort((a, b) => a.scheduled_date_iso.localeCompare(b.scheduled_date_iso));
                this.invoices = response.data.data.invoices;
                this.payments = response.data.data.payments;
                this.nextInstallment = response.data.data.next_installment
            })
            .catch(error => console.log(error))
            
        },

        uploadFileClicked() {
            console.log('Probably should upload the file...?')
        },

        showDeleteItemDialog (item) {
            // this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },

        closeDeleteItemDialog () {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                // this.editedIndex = -1
            })
        },

        showEditItemDialog (item) {
            // this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogEdit = true
        },


        closeEditItemDialog () {
            this.dialogEdit = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                // this.editedIndex = -1
            })
        },

        deleteScheduleItem(item) {
            axios.delete('/api/contract-installments/' + item.id)
            .then(() => {
                this.closeDeleteItemDialog()
                this.initialize()
            })
        },

        deleteFile(file) {

            const fileIndex = this.contract.files.indexOf(file)
            
            this.contract.files[fileIndex].is_being_deleted = true;
            
            axios.delete('/api/contract-files/' + file.id)
            .then(() => {
                this.initialize()
            })

        },

        showAddItemDialog() {
            this.editedItem = {
                amount: 0,
                scheduled_date_iso: moment().format('YYYY-MM-DD')
            }
            this.dialogCreate = true
        },

        closeAddItemDialog() {
            this.dialogCreate = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
            })
        },

        updateScheduleItem(item) {
            axios.patch('/api/contract-installments/' + item.id, {
                amount: item.amount,
                scheduled_date: item.scheduled_date_iso
            })
            .then(() => {
                this.closeEditItemDialog()
                this.initialize()
            })
        },
        
        addScheduleItem(item) {
            axios.post('/api/contract-installments', {
                contract_id: this.contract.id,
                amount: item.amount,
                scheduled_date: item.scheduled_date_iso
            })
            .then(() => {
                this.closeAddItemDialog()
                this.initialize()
            })
        },

        showAddFileDialog() {
            this.addFileDialog = true;
        },

        closeAddFileDialog() {
            this.addFileDialog = false;
        },

        totalsSum(tableData, fieldName, fixDecimals) {
            const sum = this[tableData].map(x => parseFloat(x[fieldName])).reduce((a, b) => a + b, 0)

            if (fixDecimals > 0)
                return sum.toFixed(2)

            return parseInt(sum)
        },

        tableRowClassGenerator(item) {

            if (item.is_invoiced)
                return 'green lighten-4'

            if (item.is_overdue)
                return 'red lighten-4'

        },

        getHumanDate(date) {
            return moment(date).format('DD/MM/YYYY HH:mm')
        },

        getLink(file) {
            return `/contract-files/${file.file_name}`
        },

        isBeingDeleted(file) {
            return file.is_being_deleted === true 
        }
    },

    computed: {
        showFilesCount() {
            return this.contract?.files?.length > 0
        },

        nextInstallmentDate() {
            return this.nextInstallment?.scheduled_date ?? "Δ/Υ"
        },

        nextInstallmentAmount() {
            return this.nextInstallment?.amount ?? "Δ/Υ"
        },

        contractFilesUrl() {
            return `/api/contracts/${this.contract.id}/files`
        },

        contractFilesCount() {
            return this.contract?.files?.length ?? 0
        },

   
    }
}
</script>
